import { 
  HistoricalPrescription, 
  UpdateHistoricalPrescriptionInput, 
  PrescriptionChange, 
  PrescriptionChangesMap 
} from '../types/prescription';

// Mock data for testing
// Mock data for testing - using visit IDs that match the mock prescriptions
const mockVisitPrescriptionChanges: PrescriptionChangesMap = {
  '1': [
    {
      prescriptionId: '3',
      medication: 'Omeprazole',
      changeType: 'removed',
      timestamp: new Date(Date.now() - 30 * 60 * 1000).toISOString() // 30 minutes ago
    },
    {
      prescriptionId: '5',
      medication: 'Metformin',
      changeType: 'added',
      timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString() // 15 minutes ago
    }
  ],
  '2': [
    {
      prescriptionId: '2',
      medication: 'Ibuprofen',
      changeType: 'removed',
      timestamp: new Date(Date.now() - 45 * 60 * 1000).toISOString() // 45 minutes ago
    }
  ],
  '3': [
    {
      prescriptionId: '4',
      medication: 'Cetirizine',
      changeType: 'added',
      timestamp: new Date(Date.now() - 20 * 60 * 1000).toISOString() // 20 minutes ago
    }
  ]
};

const mockPrescriptions: HistoricalPrescription[] = [
  {
    id: '1',
    visitId: '1',
    patientId: 'p1',
    medication: 'Amoxicillin',
    dosage: '500mg',
    frequency: 'Three times daily',
    duration: '7 days',
    notes: 'Take with food',
    active: true,
    prescribedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
    prescribedBy: 'd1'
  },
  {
    id: '2',
    visitId: '2',
    patientId: 'p1',
    medication: 'Ibuprofen',
    dosage: '400mg',
    frequency: 'As needed',
    duration: '5 days',
    notes: 'For pain relief',
    active: true,
    prescribedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
    prescribedBy: 'd1'
  },
  {
    id: '3',
    visitId: '3',
    patientId: 'p1',
    medication: 'Omeprazole',
    dosage: '20mg',
    frequency: 'Once daily',
    duration: '30 days',
    notes: 'Take before breakfast',
    active: false,
    prescribedAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), // 15 days ago
    prescribedBy: 'd2'
  },
  {
    id: '4',
    visitId: '4',
    patientId: 'p1',
    medication: 'Cetirizine',
    dosage: '10mg',
    frequency: 'Once daily',
    duration: '14 days',
    notes: 'For allergies',
    active: false,
    prescribedAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(), // 20 days ago
    prescribedBy: 'd1'
  },
  {
    id: '5',
    visitId: '5',
    patientId: 'p1',
    medication: 'Metformin',
    dosage: '850mg',
    frequency: 'Twice daily',
    duration: '90 days',
    notes: 'Take with meals',
    active: true,
    prescribedAt: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(), // 25 days ago
    prescribedBy: 'd2'
  },
  {
    id: '6',
    visitId: '6',
    patientId: 'p1',
    medication: 'Amlodipine',
    dosage: '5mg',
    frequency: 'Once daily',
    duration: '30 days',
    notes: 'For blood pressure',
    active: true,
    prescribedAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days ago
    prescribedBy: 'd1'
  }
];

export async function getPatientPrescriptions(patientId: string): Promise<HistoricalPrescription[]> {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log(`Fetching prescriptions for patient ${patientId}`);
  return mockPrescriptions;
}

export async function updatePrescription(input: UpdateHistoricalPrescriptionInput): Promise<HistoricalPrescription> {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const prescription = mockPrescriptions.find(p => p.id === input.id);
  if (!prescription) {
    throw new Error('Prescription not found');
  }

  // Update the prescription in the mock data
  prescription.active = input.active;
  
  return prescription;
}

// Function to get prescription changes for a visit
export async function getVisitPrescriptionChanges(visitId: string): Promise<PrescriptionChange[]> {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 300));
  console.log('Fetching changes for visit:', visitId); // Debug log
  const changes = mockVisitPrescriptionChanges[visitId] || [];
  console.log('Found changes:', changes); // Debug log
  return changes;
}
